import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const classBase = () => ({ type: ACTION.CLASS_BASE });
export const classQuery = () => ({ type: ACTION.CLASS_QUERY });
export const isLibraryLoading = () => ({ type: ACTION.LIBRARY_LOADING });
export const libraryLoaded = (classes = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, classes, totalCount, query });
export const draftsLoaded = (draftClasses = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED,  draftClasses, totalCount, query });
export const coachingLoaded = (coachingClasses = [], totalCount = null, query = '') => ({ type: ACTION.LIBRARY_LOADED, coachingClasses, totalCount, query });
export const isFilterLoading = () => ({ type: ACTION.FILTER_LOADING });
export const filterLoaded = (filters = {}) => ({ type: ACTION.FILTER_LOADED, filters });

export const getClassLibrary = (params, programType) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isLibraryLoading());
    apiService.getClasses(params)
    .then(response => {
      switch(programType){
        case 'dc': 
        dispatch(coachingLoaded(response.results, response.count));
          break
        case 'drafts':
          dispatch(draftsLoaded(response.results, response.count))
          break
        default:
          dispatch(libraryLoaded(response.results, response.count));
      }
      resolve(response);
    })
    .catch(error => {
      dispatch(classBase());
      reject(error);
    });
  });
}

export const getClassAggregate = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isFilterLoading());
    params.endpoint = 'classes';
    apiService.getAggregate(params)
    .then(response => {
      const classState = getState().classState;
      let filters = Object.assign({}, classState.filters);
      filters[params.type] = response[params.type];
      dispatch(filterLoaded(filters));
      resolve(response);
    })
    .catch(error => {
      dispatch(classBase());
      reject(error);
    });
  });
}
